<template>
	<div class="add-machine">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="addOrEdit ? $t('addMachine.add') : $t('addMachine.edit')"
			:visible.sync="dialogMachine"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="machine"
					label-width="80px"
					:model="machine">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('addMachine.teamId')" prop="teamId">
								<el-select
									v-model="machine.teamId"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									filterable
									:placeholder="$t('addMachine.pMachineGroupId')">
									<el-option
										v-for="item in machineGroup"
										:key="item.id"
										:label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('addMachine.typeId')" prop="typeId">
								<el-select
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									v-model="machine.typeId"
									filterable
									:placeholder="$t('addMachine.pMachineTypeId')">
									<el-option
										v-for="item in machineType"
										:key="item.id"
										:label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item
								:label="$t('addMachine.equipmentNo')"
								prop="equipmentNo"
								:error="error.equipmentNo">
								<el-input
									v-model="machine.equipmentNo"
									:placeholder="$t('addMachine.pMachineNo')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('addMachine.name')" prop="equipmentName">
								<el-input
									v-model="machine.equipmentName"
									:placeholder="$t('addMachine.pName')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- <el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('addMachine.appVersion')" prop="apkId">
								<el-select
									v-model="machine.apkId"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									filterable
									:placeholder="$t('addMachine.pAppVersion')"
								>
									<el-option
										v-for="item in appVersion"
										:key="item.id"
										:label="item.name"
										:value="item.id"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row> -->
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('addMachine.notes')">
								<el-input
									type="textarea"
									:rows="4"
									v-model="machine.notes"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('machine')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "AddMachine",
	props: {
		dialogMachine: Boolean,
		addOrEdit: Boolean,
		machine: Object,
		machineType: Array,
		machineGroup: Array,
		appTypeList: Array,
		// appVersion: Array,
		machineVersion: Array,
	},
	data() {
		const typeId = (rule, value, callback) => {
			if (value === "") {
				callback(new Error(this.$t("addMachine.pMachineTypeId")));
			} else {
				callback();
			}
		};
		const equipmentNo = (rule, value, callback) => {
			if (value === "") {
				callback(new Error(this.$t("addMachine.pMachineNo")));
			}
		};
		const equipmentName = (rule, value, callback) => {
			if (value === "") {
				callback(new Error(this.$t("addMachine.pName")));
			} else {
				callback();
			}
		};
		// const apkId = (rule, value, callback) => {
		// 	if (value === "") {
		// 		callback(new Error(this.$t("addMachine.pAppVersion")));
		// 	} else {
		// 		callback();
		// 	}
		// };
		const machineVersion = (rule, value, callback) => {
			if (value === "") {
				callback(new Error(this.$t("addMachine.pMachineVersion")));
			} else {
				callback();
			}
		};
		return {
			labelPosition: "top",
			clear: false,
			rules: {
				typeId: [{ validator: typeId, required: true, trigger: "blur" }],
				equipmentNo: [
					{ validator: equipmentNo, required: true, trigger: "blur" },
				],
				equipmentName: [
					{ validator: equipmentName, required: true, trigger: "blur" },
				],
				// apkId: [{ validator: apkId, required: true, trigger: "blur" }],
				machineVersion: [
					{ validator: machineVersion, required: true, trigger: "blur" },
				],
			},
			error: {
				sim: "",
				ctn: "",
				equipmentNo: "",
			},
			defaultMachineNo: "",
			loadingForm: false,
		};
	},
	mounted() {
		this.clear = false;
	},
	methods: {
		getMachineNo(equipmentNo, callback) {
			this.$api
				.request(this.$url.Machine.getMachineNo, this.$method.get, {
					equipmentNo: equipmentNo,
				})
				.then(res => {
					if (res.code === 0) {
						if (res.data) {
							callback(new Error(this.$t("addMachine.same")));
						} else {
							callback();
						}
					}
				});
		},
		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},
		submitForm() {
			//   筛选 数组appVersion

			this.loadingForm = true;
			let url = this.$url.Machine.insert;
			let method = this.$method.post;
			if (this.machine.id) {
				url = this.$url.Machine.update;
				method = this.$method.put;
			}
			this.$api
				.request(url, method, this.machine)
				.then(res => {
					if (res.code === 0) {
						this.$notify({
							title: this.$t("common.tip"),
							message: this.machine.id
								? this.$t("addMachine.up")
								: this.$t("addMachine.save"),
							type: "success",
						});
						this.clear = true;
						this.cancel(this.machine.id ? "update" : "save");
					} else {
						this.$message.warning(res.msg);
					}
					this.loadingForm = false;
				})
				.catch(() => {
					this.loadingForm = false;
				});
		},
		openDialog() {
			this.defaultMachineNo = this.machine.equipmentNo;
		},
		closeDialog() {
			this.clearValidate("machine");
			if (!this.addOrEdit) {
				this.$toolUtil.clearForm(this.machine);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.machine);
				}
			}
			this.cancel("");
		},
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
	},
};
</script>

<style scoped lang="scss">
.el-select {
	width: 100%;
}
</style>
